import { GroupedUtilityModule } from "../objects/GroupedUtilityModule";
import { store } from "@/core/modules/store/module";
import { storeTypes } from "@/core/modules/store/types";
import { User } from "@/core/modules/user/objects/User";
import { UtilityModule } from "../objects/UtilityModule";
import { utilityModules } from "../objects/utilityModules";

export class UtilityHelpers {
  public static getGroupedModules(modules: UtilityModule[]): GroupedUtilityModule[] {
    const groupedModules: GroupedUtilityModule[] = [];

    const user: User = store.getters[storeTypes.getters.getUser];

    let lastGroup: string | undefined = undefined;
    for (const module of modules) {
      if (module.requiredModule !== undefined && user.canViewUI(module.requiredModule) === false) continue;

      if (lastGroup === undefined || lastGroup != module.group) {
        const groupedModule: GroupedUtilityModule = {
          group: module.group,
          modules: [module],
        };
        groupedModules.push(groupedModule);
      } else {
        const groupedModule: GroupedUtilityModule | undefined = groupedModules.find((groupedModule) => groupedModule.group === lastGroup);
        if (groupedModule === undefined) continue;
        groupedModule.modules.push(module);
      }
      lastGroup = module.group;
    }

    return groupedModules;
  }

  public static registerModule(module: UtilityModule): void {
    if (utilityModules.includes(module) === false) {
      utilityModules.push(module);
    }
  }
}
